import { render } from "./AdverseEventMessage.vue?vue&type=template&id=7e3e1dd3&ts=true"
import script from "./AdverseEventMessage.vue?vue&type=script&lang=ts"
export * from "./AdverseEventMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserInfo/AdverseEventMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e3e1dd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e3e1dd3', __exports__)) {
    api.reload('7e3e1dd3', __exports__)
  }
  
  module.hot.accept("./AdverseEventMessage.vue?vue&type=template&id=7e3e1dd3&ts=true", () => {
    api.rerender('7e3e1dd3', render)
  })

}


export default __exports__